import _ from 'underscore';

/*********************************** HELPERS ***********************************/

/**
 * formats money like `0.00`
 *
 * @param {number} cents
 * @returns {string}
 */
export function formatMoney (cents) {
    return window.Shopify.formatMoney(cents, '{{amount}}');
}

/**
 * gets the postion of an element, like `$.fn.index()`
 *
 * @param {HTMLElement} element
 * @param {string} [selector]
 *
 * @returns number
 */
export function getElementIndex (element, selector) {
    var siblings = Array.from(element.parentNode.children);

    if (selector) {
        siblings = siblings.filter(function (sibling) {
            return sibling.matches(selector);
        });
    }

    return siblings.indexOf(element);
}

/**
 * extracts the handle from a pathname, if there is one
 *
 * @param {string} pathname defaults to `window.location.pathname`
 *
 * @returns {String?}
 */
export function getHandleForPathname (pathname) {
    if (!/\/(products|collections)\//.test(pathname || window.location.pathname)) return;
    return (pathname || window.location.pathname).split('/').pop().split('?').shift();
}

/**
* simple wrapper around MutationObserver
*
* @param {HTMLElement} target
* @param {string} selector
* @param {Function} callback called with an HTMLElement
* @param {Object} options
* @param {string} [options.dataSeen] data property to set for seen elements
* @param {boolean} [options.initial] run on existing elements
* @param {boolean} [options.once] don't keep watching
*/
export function onCreate (target, selector, callback, options) {
    var _options = _.extend({
        dataSeen: 'seen',
        initial: true,
        once: false,
    }, options || {});

    if (_options.initial) {
        const existing = Array.from(target.querySelectorAll(selector));
        for (var i in existing) {
            callback(existing[i]);
        }

        if (existing.length && _options.once) {
            return;
        }
    }

    new MutationObserver(function (mutations, observer) {
        var seen = false;

        for (var i in mutations) {
            var mutation = mutations[i];

            for (var j in mutation.addedNodes) {
                var node = mutation.addedNodes[j];

                if (node.nodeType !== document.ELEMENT_NODE) continue;

                if (node.matches(selector)) {
                    if (_options.dataSeen in node.dataset) continue;

                    callback(node, observer);
                    node.dataset[_options.dataSeen] = '';
                    seen = true;
                }

                var matches = Array.from(node.querySelectorAll(selector));
                for (var k in matches) {
                    var match = matches[k];

                    if (_options.dataSeen in match.dataset) continue;

                    callback(match, observer);
                    match.dataset[_options.dataSeen] = '';
                    seen = true;
                }
            }
        }

        if (seen && _options.once) observer.disconnect();
    }).observe(target, { childList: true, subtree: true });
}